import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/auth';
import typeReducer from '../store/type';
import countReducer from '../store/count';



const store = configureStore({
    reducer: { auth: authReducer, type: typeReducer, count: countReducer}
});


export default store;